import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import CanvasJSReact from '@canvasjs/react-charts';
import Navbar from '../components/home/Navbar';
import Footer from '../components/Footer';

const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const ViewStatDom = () => {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [details, setDetails] = useState(null);
  const [details2, setDetails2] = useState(null);

  useEffect(() => {
    const fetchYears = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'statistics_domaine'));
        const yearsSet = new Set();
        querySnapshot.forEach((doc) => {
          yearsSet.add(doc.data().annee);
        });
        const sortedYears = Array.from(yearsSet).sort((a, b) => b - a); // Sort years in descending order
        setYears(sortedYears);

        if (sortedYears.length > 0) {
          const defaultYear = sortedYears[0];
          setSelectedYear(defaultYear);
          await fetchYearData(defaultYear); // Fetch data for the default year
        }
      } catch (error) {
        console.error("Error fetching years: ", error);
      }
    };

    fetchYears();
  }, []);

  const fetchYearData = async (year) => {
    try {
      const querySnapshot = await getDocs(collection(db, 'statistics_domaine'));
      const yearData = querySnapshot.docs
        .filter(doc => doc.data().annee === year)
        .map(doc => doc.data())[0]; // Assuming there is only one document per year

      const numericData1 = {
        AgricultureNombre: Number(yearData.AgricultureNombre),
        IndustrieNombre: Number(yearData.IndustrieNombre),
        CommerceNombre: Number(yearData.CommerceNombre),
        ServicesNombre: Number(yearData.ServicesNombre),
        ArtisanatNombre: Number(yearData.ArtisanatNombre),
        Amelioration_des_conditions_de_vieNombre: Number(yearData.Amelioration_des_conditions_de_vieNombre),
        Cultures_maraicheresNombre: Number(yearData.Cultures_maraicheresNombre),
        Grandes_culturesNombre: Number(yearData.Grandes_culturesNombre),
      };
      const numericData2 = {
        AgricultureMontant: Number(yearData.AgricultureMontant),
        IndustrieMontant: Number(yearData.IndustrieMontant),
        CommerceMontant: Number(yearData.CommerceMontant),
        ServicesMontant: Number(yearData.ServicesMontant),
        ArtisanatMontant: Number(yearData.ArtisanatMontant),
        Amelioration_des_conditions_de_vieMontant: Number(yearData.Amelioration_des_conditions_de_vieMontant),
        Cultures_maraicheresMontant: Number(yearData.Cultures_maraicheresMontant),
        Grandes_culturesMontant: Number(yearData.Grandes_culturesMontant),
      };
      setDetails(numericData1);
      setDetails2(numericData2);
    } catch (error) {
      console.error("Error fetching details: ", error);
    }
  };

  const handleYearClick = async (year) => {
    setSelectedYear(year);
    await fetchYearData(year);
  };
  const labelMapping = {
    AgricultureNombre: 'Agriculture',
    IndustrieNombre: 'Industrie',
    CommerceNombre: 'Commerce',
    ServicesNombre: 'Services',
    ArtisanatNombre: 'Artisanat',
    Amelioration_des_conditions_de_vieNombre: 'Amélioration des conditions de vie',
    Cultures_maraicheresNombre: 'Cultures maraîchères',
    Grandes_culturesNombre: 'Grandes cultures',
  
    AgricultureMontant: 'Agriculture',
    IndustrieMontant: 'Industrie',
    CommerceMontant: 'Commerce',
    ServicesMontant: 'Services',
    ArtisanatMontant: 'Artisanat',
    Amelioration_des_conditions_de_vieMontant: 'Amélioration des conditions de vie',
    Cultures_maraicheresMontant: 'Cultures maraîchères',
    Grandes_culturesMontant: 'Grandes cultures'
  };
  
  const calculatePercentages2 = (data) => {
    if (!data) return [];

    const total = Object.values(data).reduce((sum, value) => sum + value, 0);
    if (total === 0) return []; // Avoid division by zero

    return [
      { label: "Agriculture", y: parseFloat((data.AgricultureMontant / total * 100).toFixed(3))}, // Blue
      { label: "Industrie", y: parseFloat((data.IndustrieMontant / total * 100).toFixed(3))}, // Orange
      { label: "Commerce", y: parseFloat((data.CommerceMontant / total * 100).toFixed(3)) }, // Green
      { label: "Services", y: parseFloat((data.ServicesMontant / total * 100).toFixed(3)) }, // Red
      { label: "Artisanat", y: parseFloat((data.ArtisanatMontant / total * 100).toFixed(3))}, // Purple
      { label: "Amélioration des conditions de vie", y: parseFloat((data.Amelioration_des_conditions_de_vieMontant / total * 100).toFixed(3)), color: "#8c564b" }, // Brown
      { label: "Cultures maraîchères", y: parseFloat((data.Cultures_maraicheresMontant / total * 100).toFixed(3)), color: "#e377c2" }, // Pink
      { label: "Grandes cultures", y: parseFloat((data.Grandes_culturesMontant / total * 100).toFixed(3)), color: "#888888	" }, // Gray
    ];
};

const calculatePercentages = (data) => {
  if (!data) return [];

  const total = Object.values(data).reduce((sum, value) => sum + value, 0);
  if (total === 0) return []; // Avoid division by zero

  return [
    { label: "Agriculture", y: parseFloat((data.AgricultureNombre / total * 100).toFixed(3))}, // Blue
    { label: "Industrie", y: parseFloat((data.IndustrieNombre / total * 100).toFixed(3))}, // Orange
    { label: "Commerce", y: parseFloat((data.CommerceNombre / total * 100).toFixed(3)) }, // Green
    { label: "Services", y: parseFloat((data.ServicesNombre / total * 100).toFixed(3)),  }, // Red
    { label: "Artisanat", y: parseFloat((data.ArtisanatNombre / total * 100).toFixed(3))}, // Purple
    { label: "Amélioration des conditions de vie", y: parseFloat((data.Amelioration_des_conditions_de_vieNombre/ total * 100).toFixed(3)), color: "#8c564b" }, // Brown
    { label: "Cultures maraîchères", y: parseFloat((data.Cultures_maraicheresNombre / total * 100).toFixed(3)), color: "#e377c2" }, // Pink
    { label: "Grandes cultures", y: parseFloat((data.Grandes_culturesNombre / total * 100).toFixed(3)), color:"#888888	"}, // Gray
  ];
};
const calculateTotals = (data) => {
  if (!data) return 0;
  return Object.values(data).reduce((sum, value) => sum + value, 0);
};

const totalMontant = calculateTotals(details2);
const totalNombre = calculateTotals(details);
  const pieOptions1 = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light1",
    title: {
      text: "",
      fontSize: 20
    },
    data: [{
      type: "pie",
      indexLabel: "{label}: {y}%", // Format for displaying percentage
      startAngle: -90,
      dataPoints: calculatePercentages2(details2),
    }]
  };

  const pieOptions2 = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light1",
    title: {
      text: "",
      fontSize: 20
    },
    data: [{
      type: "pie",
      indexLabel: "{label}: {y}%", // Format for displaying percentage
      startAngle: -90,
      dataPoints: calculatePercentages(details),
    }]
  };

  return (
    <div>
      <Navbar />
      <div style={{ display: 'flex', height: '100vh' }}>
        <div style={{
          width: '200px',
          borderRight: '1px solid #ddd',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          height: '100vh',
          boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}>
          <h3 style={{
            fontFamily: 'Arial, sans-serif',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#317873',
            margin: '0 0 20px 0',
            backgroundColor: '#ffffff',
            padding: '10px',
            borderRadius: '8px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)'
          }}>
            Années
          </h3>
          <ul style={{
            listStyleType: 'none',
            padding: 0,
            margin: 0
          }}>
            {years.map(year => (
              <li key={year}
                onClick={() => handleYearClick(year)}
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s ease',
                  marginBottom: '5px',
                  backgroundColor: '#ffffff',
                  color: '#0d47a1',
                  border: '1px solid #bbdefb'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#bbdefb'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
              >
                {year}
              </li>
            ))}
          </ul>
        </div>
  
        <div style={{ flex: 1, padding: '20px' }}>
          <div style={{
            backgroundColor: '#00674b', // Background color for the title
            color: '#ffffff', // Text color
            padding: '20px', // Padding around the text
            borderRadius: '10px', // Rounded corners
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow
            marginBottom: '20px', // Space below the title
            textAlign: 'center'
          }}>
            <h2 style={{
              fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
              fontSize: '32px',
              fontWeight: 'bold',
              margin: 0
            }}>
              Statistiques par secteur pour l'année {selectedYear || ''}
            </h2>
          </div>
  
          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '40px' }}>
            <div style={{ flex: 1, marginRight: '20px' }}>
              <h3 style={{
                fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#317873',
                margin: 0,
                padding: '10px',
                textShadow: '1px 1px 2px #ffffff, 0 0 25px rgba(255, 255, 255, 0.2)',
                borderRadius: '5px',
                textAlign: 'center'
              }}>
                Répartition par Montant
              </h3><br />
              {details2 ? (
                <>
                  <CanvasJSChart options={pieOptions1} />
                  <p style={{
                    textAlign: 'center',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#333',
                    marginTop: '10px',
                    padding: '10px',
                    borderRadius: '5px',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)'
                  }}>
                    Budget total: <span style={{ color: '#317873' }}>{totalMontant.toLocaleString()} mille dinars</span>
                  </p>
                </>
              ) : (
                <p>Loading...</p>
              )}
            </div>
  
            {/* Vertical Divider */}
          <div style={{
            position: 'absolute',
            top: '170px',
            right: '658px',
            width: '2px', // Width of the divider
            backgroundColor: '#bbb', // Color of the divider
            height: '73%', // Full height minus padding/margin
            boxShadow: '1px 0 3px rgba(0, 0, 0, 0.2)'
          }}></div>

            <div style={{ flex: 1 }}>
              <h3 style={{
                fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
                fontSize: '22px',
                fontWeight: 'bold',
                color: '#317873',
                margin: 0,
                padding: '10px',
                textShadow: '1px 1px 2px #ffffff, 0 0 25px rgba(255, 255, 255, 0.2)',
                borderRadius: '5px',
                textAlign: 'center'
              }}>
                Répartition par Nombre de personnes
              </h3><br />
              {details ? (
                <>
                  <CanvasJSChart options={pieOptions2} />
                  <p style={{
                    textAlign: 'center',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#333',
                    marginTop: '10px',
                    padding: '10px',
                    borderRadius: '5px',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)'
                  }}>
                    Nombre total des personnes: <span style={{ color: '#317873' }}>{totalNombre.toLocaleString()}</span>
                  </p>
                </>
              ) : (
                <p>Loading...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
  
};

export default ViewStatDom;